import {loadMapPinContent} from './PopupContentDialog';
import {loadMapPinAisContent} from './PopupContentDialog';
import {loadMapPinAisSpeciesSelectorContent} from './PopupContentDialog';
import {closeAllWindows} from './PopupContentDialog';
import {getInfoboxLabelOffset} from './PopupContentDialog';
import {parkLayerSettings}  from '../settings/parkLayerSettings';
import {routeLayerSettings} from '../settings/routeLayerSettings';
import {aisSiteLayerSettings} from '../settings/aisSiteLayerSettings';
import {aisReserveAssetLayerSettings} from '../settings/aisReserveAssetLayerSettings';
import {createLargeInfobox} from './PopupContentDialog';
import {loadAisSiteLayer} from './aisSiteLayer';
import {loadAisReserveAssetLayer} from './aisReserveAssetLayer';
import {aisRALayer} from './aisReserveAssetLayer';
import {aisSLayer} from './aisSiteLayer';

var ngislib = null;
var InfoBox = null;
var parkLayers = [];
var routeLayers = [];
//var aisLayers = [];
//export var aisSLayer = null;
//export var aisRALayer = null;
//export var aisReserveAssetData = [];
var infoboxOptions;
var map=null;

export async function loadMapLayers(dataSource, gMap) {
    map = gMap;
  $.getScript('/assets/NPWS/js/lib/json-converters.min.js');
  $.getScript('/assets/NPWS/js/lib/ngis.min.js', function () {
      ngislib = window.ngislib;
      InfoBox = window.InfoBox;
      infoboxOptions = {
          alignBottom: true,
          disableAutoPan: false,
          maxWidth: 380,
          pixelOffset: new google.maps.Size(5, 5),
          zIndex: null,
          closeBoxURL: '',
          infoBoxClearance: new google.maps.Size(5, 5),
          isHidden: false,
          pane: 'floatPane',
          enableEventPropagation: false,
      };
      gMap.highlightedFeatures = [];
      gMap.isFeatureHighlighted = function (gisId) {
          for (let i = 0; i < this.highlightedFeatures.length; i++) {
              var highlightedFeatureId = this.highlightedFeatures[i];
              if (highlightedFeatureId == gisId)
                  return true;
          }
          return false;
      };
      gMap.featureHighlighted = function (gisId, isHighlighted) {
          var index = this.highlightedFeatures.indexOf(gisId);
          if (isHighlighted) {
              if (index >= 0)
                  return;
              this.highlightedFeatures.push(gisId);
          }
          if (index < 0)
              return;
          this.highlightedFeatures.splice(index, 1);
      };
      gMap.toggleFeatureHighlightStatus = function (gisId) {
          var isHighlighted = this.isFeatureHighlighted(gisId);
          isHighlighted = !isHighlighted;
          this.featureHighlighted(gisId, isHighlighted);
      }
      loadMapLayerApiCall(dataSource, gMap);
  });
}

async function loadMapLayerApiCall(dataSource, gMap) {
  const hostname = '//' + location.hostname;
  const endpointPath = '/data/map/GetCustomLayers/?dataSource=';
  try {
      const response = await fetch(hostname + endpointPath + dataSource);
      const data = await response.json();

      if (data != "" && data.Layers.length > 0) {

          const layerData = data.Layers.map((l) => {
            //alert(l.Type);
                  if (l.Type == "Park") {
                      var parkGuids = "";
                      if (!l.ShowAllParks) {
                          l.Parks.map((p) => {
                              if (parkGuids.length > 0)
                                  parkGuids += " or ";
                              parkGuids += "GUID='" + p.GisId + "'";
                          });
                          if (parkGuids.length > 0)
                              parkGuids = "(" + parkGuids + ")";
                      };

                      var x = loadParkLayer(gMap, l, parkGuids);

                      var parkLayer = parkLayers[parkLayers.length - 1];
                      parkLayer.markers = [];
                      l.Parks.map((p) => {
                          parkLayer.itemId = p.ItemId;
                          if (p.Visible) {
                              if (p.IsActive) {
                                  parkLayer.activeFeatures.push(p.GisId);
                              } else {
                                  parkLayer.visibleFeatures.push(p.GisId);
                              }
                          }
                      });

                      if (l.ShowActiveParkPins && typeof l.ActiveParkPins !== 'undefined' && l.ActiveParkPins !== null) {
                          l.ActiveParkPins.map((p) => {
                              createPin(parkLayer, hostname, p, gMap, l.ShowActiveParkLabel);
                          });
                      }
                      if (l.ShowVisibleParkPins && typeof l.VisibleParkPins !== 'undefined' && l.VisibleParkPins !== null) {
                          l.VisibleParkPins.map((p) => {
                              createPin(parkLayer, hostname, p, gMap, l.ShowVisibleParkLabel);
                          });
                      }

                      var zoomLevel = parkLayer.map.getZoom();
                      var isVisible = (parkLayer.minZoom <= zoomLevel) && (zoomLevel <= parkLayer.maxZoom);
                      parkLayer.SetVisible(isVisible);
                      var markers = parkLayer.markers.map((m) => {
                              m.visible = isVisible;
                              if (m.fixedInfoBox !== null) {
                                  if (isVisible) {
                                      m.fixedInfoBox.open(m.map);
                                  } else {
                                      m.fixedInfoBox.close();
                                  }
                              }
                          });
                  };
                  if (l.Type == "Route") {
                        var routeGuids = "";
                        l.Routes.map((r) => {
                        if (routeGuids.length > 0)
                            routeGuids += " or ";
                            routeGuids += "GUID='" + r.GisId + "'";
                        });
                        if (routeGuids.length > 0)
                        routeGuids = "(" + routeGuids + ")";

                        var x = loadRouteLayer(gMap, l, routeGuids);
                        
                        var routeLayer = routeLayers[routeLayers.length - 1];
                        routeLayer.markers = [];
                        l.Routes.map((r) => {
                            routeLayer.itemId = r.ItemId;
                            if (r.Visible) {
                                if (r.IsActive) {
                                    routeLayer.activeFeatures.push(r.GisId);
                                } else {
                                    routeLayer.visibleFeatures.push(r.GisId);
                                }
                            }
                        });
                         
                      if (l.ShowActiveRoutePins && typeof l.ActiveRoutePins !== 'undefined' && l.ActiveRoutePins !== null) {
                          l.ActiveRoutePins.map((p) => {
                              createPin(routeLayer, hostname, p, gMap, l.ShowActiveRouteLabel);
                          });
                      }
                      if (l.ShowVisibleRoutePins && typeof l.VisibleRoutePins !== 'undefined' && l.VisibleRoutePins !== null) {
                          l.VisibleRoutePins.map((p) => {
                              createPin(routeLayer, hostname, p, gMap, l.ShowVisibleRouteLabel);
                          });
                      }

                      var zoomLevel = routeLayer.map.getZoom();
                      var isVisible = (routeLayer.minZoom <= zoomLevel) && (zoomLevel <= routeLayer.maxZoom);
                      routeLayer.SetVisible(isVisible);
                      var markers = routeLayer.markers.map((m) => {
                              m.visible = isVisible;
                              if (m.fixedInfoBox !== null) {
                                  if (isVisible) {
                                      m.fixedInfoBox.open(m.map);
                                  } else {
                                      m.fixedInfoBox.close();
                                  }
                              }
                          });                        
                  }
                  // AIS site
                  if (l.Type == "AisSite") {
                    //loadDataTableData();
    
                    var aisSiteIds = "";
                    if (!l.ShowAllSites) {
                        l.AisSites.map((p) => {
                            if (aisSiteIds.length > 0)
                            aisSiteIds += " or ";
                            aisSiteIds += "xxxx='" + p.GisId + "'";
                        });
                        if (aisSiteIds.length > 0)
                        aisSiteIds = "(" + aisSiteIds + ")";
                    };

                    //aisSLayer = loadAisSiteLayer(gMap, l, "parkGuids");
                    loadAisSiteLayer(gMap, l, "");

                    //aisSLayer.markers = [];

                    var zoomLevel = aisSLayer.map.getZoom();
                    var isVisible = (aisSLayer.minZoom <= zoomLevel) && (zoomLevel <= aisSLayer.maxZoom);
                    aisSLayer.SetVisible(isVisible);
                };

                // AIS reserve assets
                if (l.Type == "AisReserveAssets") {
                    //loadDataTableData();
    
                    var aisReserveAssetIds = "";
                    loadAisReserveAssetLayer(gMap, l, "");

                    var zoomLevel = aisRALayer.map.getZoom();
                    var isVisible = (aisRALayer.minZoom <= zoomLevel) && (zoomLevel <= aisRALayer.maxZoom);
                    aisRALayer.SetVisible(isVisible);
                };
              });

          google.maps.event.trigger(
              gMap,
              'idle');
      }
  } catch (error) {
      console.warn(`Request issue ${error}`);
  }

}
function createPin(layer, hostname, parkPin, gMap, showLabel) {
  var pinWidth = 0;
  var pinHeight = 0;
  var pinIcon = "";
  //if (module.pins.canonicalizeId(pin.id) == module.pins.canonicalizeId(mapSettings.selected)) {
  

  var pinImagePath = '/assets/NPWS/images/map-pins/';

  var pinIcon;
  if (
      typeof parkPin.PSubType !== 'undefined' && parkPin.PSubType !== null && parkPin.PSubType !== '') {
      pinIcon = parkPin.PSubType;
  } else {
      pinIcon = parkPin.PType;
  }

  if (parkPin.PType == 'subatt') {
      pinImagePath += 'subattraction/';
  }
  if (parkPin.PTemplate == 't3') {
    pinIcon = 't3-park';
    pinWidth = 24;
    pinHeight = 28;
} else {
    pinWidth = 34;
    pinHeight = 39;
}

  var image;
  
  if (Modernizr.highres && parkPin.PType != 'subatt') {
      // Detect retina displays and load high res pin if necessary
      image = new google.maps.MarkerImage(
              pinImagePath + '/retina/' + pinIcon + '.png',
              null,
              null,
              null,
              new google.maps.Size(pinWidth, pinHeight));
  } else {
      image = new google.maps.MarkerImage(
              pinImagePath + pinIcon + '.png',
              new google.maps.Size(pinWidth, pinHeight));
  }
  //var iconUrl = hostname + parkPin.IconUrl;
  var marker = new google.maps.Marker({
          position: new google.maps.LatLng(parkPin.Lat, parkPin.Lng),
          title: parkPin.Title,
          map: gMap,
          //icon: iconUrl,
          icon: image
      });
  marker.pinHeight = pinHeight;
  marker.sourceItem = parkPin.SourceItem;
  marker.gisId = parkPin.GisId;
  layer.markers.push(marker);
  marker.addListener('click', () => {
      loadMapPinContent(marker);
  });
  marker.fixedInfoBox = (showLabel) ? createHoverInfobox(marker, pinHeight) : null;
}
function updateFeatureStyles(layer) {
  layer.processFeatureStyles(layer.activeFeatures, true);
  layer.processFeatureStyles(layer.visibleFeatures, false);
}

/*function processFeatureStyles(layer, features, isActiveFeature) {
  var map = layer.map;
  if (features.length == 0)
      return;
  for (let i = 0; i < features.length; i++) {
      var gisId = features[i];
      layer.FindById(gisId, function (feature) {
          console.log("processFeatureStyles gisId=" + gisId);
          showParkHighlight(layer, feature, gisId, isActiveFeature);
          console.log("processFeatureStyles end gisId=" + gisId);          
      });
  }
}*/
/*function isActiveFeature(layer, fGisId) {
  var aFeatures = layer.activeFeatures;
  if (aFeatures.length == 0)
      return false;
  for (let i = 0; i < aFeatures.length; i++) {
      var gisId = aFeatures[i];
      if (gisId == fGisId)
          return true;
  }
  return false;
}*/

function loadParkLayer(gMap, apiLayer, guidFilter) {
  var deferred = new $.Deferred();

  var parkLayer = new ngislib.DynamicAGOLayer({
          url: 'https://services1.arcgis.com/RYwXzrqre8JeYrSa/ArcGIS/rest/services/Estate/FeatureServer/0',
          idField: 'GUID',
          map: gMap,
          hasLOD: true,
          userFilter: guidFilter,
          outFields: 'GUID,NAME'
      });

  parkLayer.LayerId = parkLayers.length + 1;

  parkLayer.minZoom = apiLayer.MinLayerVisibility;
  parkLayer.maxZoom = apiLayer.MaxLayerVisibility;

  parkLayer.activeParkClickAction = apiLayer.ActiveParkClickAction;
  parkLayer.activeParkHighlightColour = apiLayer.ActiveParkHighlightColour;
  parkLayer.visibleParkClickAction = apiLayer.VisibleParkClickAction;
  parkLayer.visibleParkHighlightColour = apiLayer.VisibleParkHighlightColour;

  parkLayers.push(parkLayer);
  //layer.SetVisible(false);
  parkLayer.activeFeatures = [];
  parkLayer.visibleFeatures = [];
  parkLayer.processFeatureStyles=function (features, isActiveFeature) {
    //var map = this.map;
    if (features.length == 0)
        return;
        //var layer=this;
    for (let i = 0; i < features.length; i++) {
        var gisId = features[i];
        this.FindById(gisId, function (feature) {
            parkLayer.showParkHighlight(feature, gisId, isActiveFeature);
        });
    }
  }
  
  parkLayer.showParkHighlight=function (feat, gisId, isActiveFeature) {
    var map = this.map;
    var isHighlighted = map.isFeatureHighlighted(gisId);
    var zoomLevel = map.getZoom();
    //console.log("showParkHighlight isHighlighted=" + isHighlighted + " isActiveFeature=" + isActiveFeature + " LayerId=" + this.LayerId);   

    var layerHasParkHighlightClickFunctionality=false;
    if(isActiveFeature){
      layerHasParkHighlightClickFunctionality=this.activeParkClickAction.match(/parkHighlight/i) != null;
    }else{
      layerHasParkHighlightClickFunctionality=this.visibleParkClickAction.match(/parkHighlight/i) != null;
    }
      
    if (isHighlighted && layerHasParkHighlightClickFunctionality) {
        //layer.overrideStyle(feat,parkLayerSettings.activeParks.styles.clickedActive);
        var highlightColor = {
          fillOpacity: 0.7,
            fillColor: '#4d7c28',
            strokeColor: '#ffffff',
            strokeWeight: 1,
            strokeOpacity: 1,
            zIndex: -1,
      };
      
        if (isActiveFeature) {
            var highlightColor= {
              fillOpacity: 0.7,
              fillColor: this.activeParkHighlightColour,
              strokeColor: '#ffffff',
              strokeWeight: 1,
              strokeOpacity: 1,
              zIndex: -1,
            };
            this.overrideStyle(feat, highlightColor);
        } else {
          var highlightColor= {
            fillOpacity: 0.4,
            fillColor: this.visibleParkHighlightColour,
            strokeColor: '#ffffff',
            strokeWeight: 1,
            strokeOpacity: 1,
            zIndex: 1
          };
            this.overrideStyle(feat, highlightColor);
        }
    } else {
        if (isActiveFeature) {
            this.overrideStyle(feat, parkLayerSettings.activeParks.styles.selected);
        } else {
            this.overrideStyle(feat, parkLayerSettings.inactiveParks.styles.defaultState);
        }
    }
    return isHighlighted;
  }

  parkLayer.isActiveFeature = function(fGisId) {
    var aFeatures = this.activeFeatures;
    if (aFeatures.length == 0)
        return false;
    for (let i = 0; i < aFeatures.length; i++) {
        var gisId = aFeatures[i];
        if (gisId == fGisId)
            return true;
    }
    return false;
  }
  parkLayer.setStyle(parkLayerSettings.inactiveParks.styles.defaultState);

  parkLayer.getMarker=function (gisId) {
    var markers = this.markers;
    gisId = gisId.replace("{", "").replace("}", "").toLowerCase();
    if (markers.length == 0)
        return null;
    for (let i = 0; i < markers.length; i++) {
        var marker = markers[i];
        if (gisId == marker.gisId) {
            return marker;
        }
    }
    return null;
  }

  /* *** Add layer listeners *** */
  google.maps.event.addListener(parkLayer, 'click', function (event) {
      var feat = event.feature;
      var map = parkLayer.map;
      var featId = false;
      if (typeof feat !== 'undefined' && feat !== null) {
          featId = feat.getId();
      }

      if (featId) {
          var gisId = feat.getId();

          var activeFeature = parkLayer.isActiveFeature(gisId);

          if (activeFeature) {
              var isHighlighted = true;
              if (parkLayer.activeParkClickAction.match(/parkHighlight/i) != null) {
                  console.log("Click show highlight layerId=" + parkLayer.LayerId + " " + gisId + " " + feat);

                  map.toggleFeatureHighlightStatus(gisId);
                  isHighlighted = parkLayer.showParkHighlight(feat, gisId, activeFeature);
              }
              if (isHighlighted && parkLayer.activeParkClickAction.match(/parkDetails/i) != null) {
                  var marker = parkLayer.getMarker(gisId);
                  console.log("Click activeFeature  isHighlighted parkDetails  layerId=" + parkLayer.LayerId);
                  if (marker != null)
                      loadMapPinContent(marker);
              }
          } else {
              console.log("Click visibleFeature " + parkLayer.visibleParkClickAction);
              var isHighlighted = true;
              if (parkLayer.visibleParkClickAction.match(/parkHighlight/i) != null) {

                  var isHighlighted = map.isFeatureHighlighted(gisId);
                  isHighlighted = !isHighlighted;
                  map.featureHighlighted(gisId, isHighlighted);

                  isHighlighted = parkLayer.showParkHighlight(feat, gisId, activeFeature);
              }
              if (isHighlighted && parkLayer.visibleParkClickAction.match(/parkDetails/i) != null) {
                  var marker = parkLayer.getMarker(gisId);
                  if (marker != null)
                      loadMapPinContent(marker);
              }
          }

      }

  });

  google.maps.event.addListener(
      parkLayer,
      'status_changed',
      function () {
      //when parkLayer is panned, the park layer is refreshed, so does the data
      //so every feature that has been set is reset to initial state
      updateFeatureStyles(parkLayer);
  });

  /* *** End add layer listeners *** */

  /* *** Add map listeners *** */

  google.maps.event.addListener(parkLayer.map, 'zoom_changed',
      function (e) {
      var zoomLevel = this.getZoom();
      var map = this;
      var isVisible = (parkLayer.minZoom <= zoomLevel) && (zoomLevel <= parkLayer.maxZoom);

      parkLayer.SetVisible(isVisible);
      var markers = parkLayer.markers.map((m) => {
              m.setVisible(isVisible);
              if (m.fixedInfoBox != null) {
                  if (isVisible) {
                      m.fixedInfoBox.open(map);
                  } else {
                      m.fixedInfoBox.close();

                      if(map.lastSourceItem == m.sourceItem)closeAllWindows();
                  }
              }
          });
  });

  /* *** End add map listeners *** */

  //return deferred.promise();
  deferred.promise();
  return parkLayer;
}

function loadRouteLayer(gMap, apiLayer, guidFilter){
   //alert(guidFilter);
   var deferred = new $.Deferred();

  var routeLayer = new ngislib.DynamicAGOLayer({
          url: 'https://services1.arcgis.com/RYwXzrqre8JeYrSa/ArcGIS/rest/services/VisitorRoute/FeatureServer/0',
          idField: 'GUID',
          map: gMap,
          hasLOD: true,
          userFilter: guidFilter,
          outFields: 'GUID,NAME'
      });

      routeLayer.LayerId = routeLayers.length + 1;

      routeLayer.minZoom = apiLayer.MinLayerVisibility;
      routeLayer.maxZoom = apiLayer.MaxLayerVisibility;
    
      routeLayer.activeRouteClickAction = apiLayer.ActiveRouteClickAction;
      routeLayer.activeRouteHighlightColour = apiLayer.ActiveRouteHighlightColour;
      routeLayer.visibleRouteClickAction = apiLayer.VisibleRouteClickAction;
      routeLayer.visibleRouteHighlightColour = apiLayer.VisibleRouteHighlightColour;
    
      routeLayers.push(routeLayer);
      routeLayer.activeFeatures = [];
      routeLayer.visibleFeatures = [];
      routeLayer.processFeatureStyles=function (features, isActiveFeature) {
        //var map = this.map;
        //console.log("route feature length=" + features.length);
        if (features.length == 0)
            return;
            //var layer=this;
        for (let i = 0; i < features.length; i++) {
            var gisId = features[i];
            this.FindById(gisId, function (feature) {
                //console.log("showRouteHighlight=" + feature);
                routeLayer.showRouteHighlight(feature, gisId, isActiveFeature);
            });
        }
      }

      
 routeLayer.showRouteHighlight=function (feat, gisId, isActiveFeature) {
     var map = this.map;
     var isHighlighted = map.isFeatureHighlighted(gisId);
     var zoomLevel = map.getZoom();
     //alert(feat + " " + gisId + " " + isActiveFeature + " " + isHighlighted + " " + zoomLevel);
     
     var layerHasRouteHighlightClickFunctionality=false;
     if(isActiveFeature){
       layerHasRouteHighlightClickFunctionality=this.activeRouteClickAction.match(/routeHighlight/i) != null;
     }else{
       layerHasRouteHighlightClickFunctionality=this.visibleRouteClickAction.match(/routeHighlight/i) != null;
     }
     //console.log("showRouteHighlight isHighlighted=" + isHighlighted + " isActiveFeature=" + isActiveFeature + " LayerId=" + this.LayerId + " layerHasRouteHighlightClickFunctionality=" + layerHasRouteHighlightClickFunctionality);   
 
     if (isHighlighted && layerHasRouteHighlightClickFunctionality) {
         if (isActiveFeature) {
            var highlightColor= {
                fillOpacity: 1,
              fillColor: this.activeRouteHighlightColour,
              strokeColor: this.activeRouteHighlightColour,
              strokeWeight: 4,
              strokeOpacity: 1,
              zIndex: 30,              
            };
            this.overrideStyle(feat, highlightColor);
         } else {
             var highlightColor= {
                fillOpacity: 0.4,
                fillColor: this.visibleRouteHighlightColour,
                strokeColor: this.visibleRouteHighlightColour, //'#bcf57b',
                strokeWeight: 4,
                strokeOpacity: 1,
                zIndex: 30
            };
                this.overrideStyle(feat, highlightColor);
         }
     } else {
          if (isActiveFeature) {
            this.overrideStyle(feat, routeLayerSettings.activeRoutes.styles.defaultState);
          } else {
              this.overrideStyle(feat, routeLayerSettings.inactiveRoutes.styles.defaultState);
          }
     }
     return isHighlighted;
}

  routeLayer.isActiveFeature = function(fGisId) {
    var aFeatures = this.activeFeatures;
    if (aFeatures.length == 0)
        return false;
    for (let i = 0; i < aFeatures.length; i++) {
        var gisId = aFeatures[i];
        if (gisId == fGisId)
            return true;
    }
    return false;
  }
   routeLayer.setStyle(routeLayerSettings.inactiveRoutes.styles.defaultState);

   routeLayer.getMarker=function (gisId) {
    var markers = this.markers;
    gisId = gisId.replace("{", "").replace("}", "").toLowerCase();
    if (markers.length == 0)
        return null;
    for (let i = 0; i < markers.length; i++) {
        var marker = markers[i];
        if (gisId == marker.gisId) {
            return marker;
        }
    }
    return null;
  }

  /* *** Add layer listeners *** */
  google.maps.event.addListener(routeLayer, 'click', function (event) {
    var feat = event.feature;
    var map = routeLayer.map;
    var featId = false;
    if (typeof feat !== 'undefined' && feat !== null) {
        featId = feat.getId();
    }
    if (featId) {
        var gisId = feat.getId();

        var activeFeature = routeLayer.isActiveFeature(gisId);

        if (activeFeature) {
            var isHighlighted = true;
            if (routeLayer.activeRouteClickAction.match(/routeHighlight/i) != null) {
                console.log("Click show highlight layerId=" + routeLayer.LayerId + " " + gisId + " " + feat);

                map.toggleFeatureHighlightStatus(gisId);
                isHighlighted = routeLayer.showRouteHighlight(feat, gisId, activeFeature);
            }
            if (isHighlighted && routeLayer.activeRouteClickAction.match(/routeDetails/i) != null) {
                var marker = routeLayer.getMarker(gisId);
                console.log("Click activeFeature isHighlighted routeDetails  layerId=" + routeLayer.LayerId);
                if (marker != null)
                    loadMapPinContent(marker);
            }
        } else {
            console.log("Click visibleFeature " + routeLayer.visibleRouteClickAction);
            var isHighlighted = true;
            if (routeLayer.visibleRouteClickAction.match(/routeHighlight/i) != null) {

                isHighlighted = map.isFeatureHighlighted(gisId);
                isHighlighted = !isHighlighted;
                map.featureHighlighted(gisId, isHighlighted);

                isHighlighted = routeLayer.showRouteHighlight(feat, gisId, activeFeature);
            }
            if (isHighlighted && routeLayer.visibleRouteClickAction.match(/routeDetails/i) != null) {
                var marker = routeLayer.getMarker(gisId);
                if (marker != null)
                    loadMapPinContent(marker);
            }
        }
    }

});

google.maps.event.addListener(
    routeLayer,
    'status_changed',
    function () {
    //when parkLayer is panned, the park layer is refreshed, so does the data
    //so every feature that has been set is reset to initial state
    updateFeatureStyles(routeLayer);
});

/* *** End add layer listeners *** */

 /* *** Add map listeners *** */

google.maps.event.addListener(routeLayer.map, 'zoom_changed',
    function (e) {
    var zoomLevel = this.getZoom();
    var map = this;
    
    var isVisible = (routeLayer.minZoom <= zoomLevel) && (zoomLevel <= routeLayer.maxZoom);
    //console.log("RL zoom_changed map=" + map + " zoomLevel=" + zoomLevel + " isVisible=" + isVisible);
    routeLayer.SetVisible(isVisible);
    
    var markers = routeLayer.markers.map((m) => {
        //console.log("RL markers m=" + m + " m.fixedInfoBox=" + m.fixedInfoBox + " isVisible=" + isVisible);
            m.setVisible(isVisible);
            if (m.fixedInfoBox != null) {
                if (isVisible) {
                    m.fixedInfoBox.open(map);
                } else {
                    m.fixedInfoBox.close();

                    if(map.lastSourceItem == m.sourceItem)closeAllWindows();
                }
            }
        });
});

/* *** End add map listeners *** */



      
   //return deferred.promise();
  deferred.promise();
  return routeLayer;
}

/* *** Helper methods *** */

function createHoverInfobox(marker, pinHeight) {
  var anchor; //the anchor could be a marker or a cluster
  var offset; //this could be a pin height or an offset (if the anchor is a cluster cluster)
  var box = new InfoBox(infoboxOptions);
  var title = (marker.type == 'ep' ? 'Park entry point: ' : '') + marker.title;

  if (marker.type == 'subatt') {
      //var parentMarker = module.pins.findPinByItemId(marker.parentAttr);
      //title += ' (a part of ' + parentMarker.title_ + ')';
  }

  box.content_ =
      '<div class="infoBox__inner label"><p>' + title + '</p></div>';

  if (typeof marker.cluster !== 'undefined' && marker.cluster !== null) {
      var clusterMarker = marker.cluster;
      //this is needed to emulate a getPosition from a marker
      clusterMarker.getPosition = function () {
          return marker.cluster.getCenter();
      };
      offset = 15;
      anchor = clusterMarker;
  } else {
      offset = pinHeight || 2; //if pinHeight is undefined, use 2 instead (i.e clicking a route)
      anchor = marker;
  }

  //if entry point, the offset should be determined from the box.content, otherwise, it's the title/marker.title_
  box.pixelOffset_ = getInfoboxLabelOffset(
          marker.type == 'ep' ? box.content_ : title,
          offset);
  box.disableAutoPan_ = true;
  box.pin = marker;
  box.open(marker.map, anchor);
  return box;



}

 


